﻿import { ProjectMilestoneStatus, RIGHTS } from "@/enums";
import { useIsAdmin } from "@/helpers/permissions";
import { IMilestone } from "@/interfaces";
import { useProjectContext, useUserContext } from "@/providers";
import { useEffect, useState } from "react";

export const useDeleteMilestonePermission = ({
  status,
  canBeDeleted,
  name,
}: IMilestone): boolean => {
  const { hasRight } = useUserContext();
  const isAdmin = useIsAdmin();
  const { isUserProjectLeader } = useProjectContext();
  const [canDeleteMilestone, setCanDeleteMilestone] = useState(false);
  const [userHasDeleteAccess, setUserHasDeleteAccess] = useState(false);

  useEffect(() => {
    setUserHasDeleteAccess(
      hasRight([RIGHTS.deleteProjectMilestone]) || isUserProjectLeader()
    );
  }, [hasRight, isUserProjectLeader]);

  useEffect(() => {
    if (isAdmin) {
      const isInApproval = status === ProjectMilestoneStatus.InApproval;
      setCanDeleteMilestone(canBeDeleted && !isInApproval);
    } else {
      const isDraftMilestone = status === ProjectMilestoneStatus.Draft;
      setCanDeleteMilestone(
        isDraftMilestone && canBeDeleted && userHasDeleteAccess
      );
    }
  }, [hasRight, userHasDeleteAccess, canBeDeleted, status]);

  return canDeleteMilestone;
};
